<template>
  <teleport to="body">
    <div class="fixed inset-0 flex justify-center items-center bg-black/70 z-50" v-if="visible">
      <div class="bg-white w-[275px] p-4 rounded-md text-black">
        <div class="mt-4 mb-5 font-bold text-lg text-center">{{ $t('camera_access.title') }}</div>
        <div class="mb-5">
          <p>{{ $t('camera_access.fix_issue') }}</p>
          <ul class="ltr:pl-8 rtl:pr-8">
            <li class="mb-4">{{ $t('camera_access.enable_phone_setting') }}</li>
            <li class="mb-4">{{ $t('camera_access.enable_browser_setting') }}</li>
            <li>{{ $t('camera_access.close_other_apps') }}</li>
          </ul>
        </div>
        <div class="py-3 px-0 text-lg text-[#15BBF0] text-center" @click="handleReload()">
          {{ $t('camera_access.try_again') }}
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false
  }
})

const handleReload = () => {
  window.location.reload()
}
</script>